import { render } from "./Thilim.vue?vue&type=template&id=5d04a678"
import script from "./Thilim.vue?vue&type=script&lang=js"
export * from "./Thilim.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__